import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AvBarChartComponent } from '../../../../../Shared/Components/av-bar-chart/av-bar-chart.component';
import { AvEmptyStateComponent } from '../../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { MonitoringByKind } from '../../../Interfaces/monitoring-report.interface';
import { toKindBars } from '../../../Shared/monitoring-chart-data.util';

@Component({
  selector: 'app-monitoring-kind-comparison',
  standalone: true,
  imports: [COMMON_IMPORTS, AvBarChartComponent, AvEmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-kind-comparison.component.html',
  styleUrl: './monitoring-kind-comparison.component.scss',
  host: { class: 'av-metric-card' },
})
export class MonitoringKindComparisonComponent {
  readonly byKind = input.required<MonitoringByKind>();

  protected readonly bars = computed(() => toKindBars(this.byKind()));

  protected readonly isEmpty = computed(() => this.bars().every((bar) => bar.value === 0));
}
